module.exports = __webpack_public_path__ + "static/media/delivery.1929aa1c.svg";